var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.5C7.15625 6.5 7.5 6.84375 7.5 7.25V8.75C7.5 9.1875 7.15625 9.5 6.75 9.5H5.25C4.8125 9.5 4.5 9.1875 4.5 8.75V7.25C4.5 6.84375 4.8125 6.5 5.25 6.5H6.75ZM19.25 7.25C19.6562 7.25 20 7.59375 20 8C20 8.4375 19.6562 8.75 19.25 8.75H9.75C9.3125 8.75 9 8.4375 9 8C9 7.59375 9.3125 7.25 9.75 7.25H19.25ZM19.25 12.25C19.6562 12.25 20 12.5938 20 13C20 13.4375 19.6562 13.75 19.25 13.75H9.75C9.3125 13.75 9 13.4375 9 13C9 12.5938 9.3125 12.25 9.75 12.25H19.25ZM19.25 17.25C19.6562 17.25 20 17.5938 20 18C20 18.4375 19.6562 18.75 19.25 18.75H9.75C9.3125 18.75 9 18.4375 9 18C9 17.5938 9.3125 17.25 9.75 17.25H19.25ZM4.5 12.25C4.5 11.8438 4.8125 11.5 5.25 11.5H6.75C7.15625 11.5 7.5 11.8438 7.5 12.25V13.75C7.5 14.1875 7.15625 14.5 6.75 14.5H5.25C4.8125 14.5 4.5 14.1875 4.5 13.75V12.25ZM6.75 16.5C7.15625 16.5 7.5 16.8438 7.5 17.25V18.75C7.5 19.1875 7.15625 19.5 6.75 19.5H5.25C4.8125 19.5 4.5 19.1875 4.5 18.75V17.25C4.5 16.8438 4.8125 16.5 5.25 16.5H6.75Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.08ef10dd05e239c3d8d5f3488455d0f3.svg";
export { ForwardRef as ReactComponent };